import React from "react";
interface Props {
    src?: string;
    className?: string;
}

export class Avatar extends React.Component<Props> {
    render() {
        const src = this.props.src || 'https://swivl-cdn.s3-us-west-1.amazonaws.com/studio/member-avatar-blank.png'
        return <img className={"w-10 h-10 rounded-full " + (this.props.className || "")  } src={src} alt="avatar" />
    }
}

export class LocationAvatar extends React.Component<Props> {
    render() {
        const src = this.props.src || 'https://swivl-cdn.s3-us-west-1.amazonaws.com/studio/member-avatar-blank.png'
        return <img className={"w-10 h-10 rounded-sm " + (this.props.className || "")  } src={src} alt="avatar" />
    }
}